export function getReturnUrl() {
  return encodeURIComponent(window.location.href);
}
